import { addScriptToHead } from "./addScriptToHead";

export async function loadGameScripts() {
	if (!window.gameChunks?.length) {
		throw new Error("gameChunks are empty");
	}

	await Promise.all(
		window.gameChunks
			.map(chunkName => `${chunkName}.js`)
			.map(addScriptToHead)
	);
}
